import type { ChatResponseType } from '../../enums';
import type { Chat } from '../../types';
import { safeJsonDate, safeJsonDateRequired, transformDates } from './date';

export function transformChatQuery(data: Chat.Query<ChatResponseType, string>): Chat.Query {
  return {
    ...data,
    state: transformDates(data.state) as Chat.QueryState.Value<ChatResponseType>,
    citations: data.citations.map<Chat.Citation>(citation => transformDates(citation) as Chat.Citation),
    createdOn: safeJsonDateRequired(data.createdOn),
  };
}